import { SponsoredProductsPage } from '../configs/tools/shared-library/product-feed';

export const brands = {
  ...SponsoredProductsPage,
  description: _TL_('Partner with retailers selling your products.'),
  children: [],
};
